/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/** @jsx jsx */
import { css, jsx } from '@emotion/react'

import {
  EuiHeaderLogo,
  EuiHeaderSection,
  EuiHeaderSectionItem,
  keys,
  useEuiTheme,
} from '@elastic/eui'

import history from '@modules/utils/history'

import ElasticMark from './ElasticMark'

interface Props {}

const HeaderNavigation: React.FC<Props> = () => {
  const { euiTheme } = useEuiTheme()

  const onHeaderLogoKeyDown = (event) => {
    if (event.key === keys.ENTER) {
      gotoHomePage()
    }
  }

  const gotoHomePage = () => {
    history.push('/')
  }

  return (
    <EuiHeaderSection>
      <EuiHeaderSectionItem>
        <EuiHeaderLogo
          data-test-id='header-logo'
          data-test-subj='ebt.home.header-logo'
          onClick={() => gotoHomePage()}
          onKeyDown={onHeaderLogoKeyDown}
          className='headerNavigation_logo'
          css={css`
            cursor: pointer;
            &:hover {
              cursor: pointer;
            }
            .euiHeaderLogo__text {
              display: flex;
            }
            .headerNavigation_elasticMark {
              fill: ${euiTheme.colors.textGhost};
            }
          `}
          iconType='logoElastic'
          iconTitle=''
          aria-label='Elastic'
          role='link'
          tabIndex={0}
        >
          <ElasticMark className='headerNavigation_elasticMark' />
        </EuiHeaderLogo>
      </EuiHeaderSectionItem>
    </EuiHeaderSection>
  )
}

export default HeaderNavigation
